module.exports = __webpack_public_path__ + "static/media/champion_icon.1661306f.webp";